const getRescheduleTypeListResponse = (response) => {
  const result = response?.scheduleType?.map((type) => {
    return {
      value: type?.id,
      label: type?.name,
      isAvailable: type?.isAvailable,
    };
  });
  return result;
};

export default getRescheduleTypeListResponse;
